import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "abandonLeader", "refunded"]

  confirm() {
    if (this.refundedTarget.checked) {
      this.dialogTarget.showModal()
    }
  }

  yes() {
    this.abandonLeaderTarget.value = "1"
    this.dialogTarget.close()
  }

  no() {
    this.abandonLeaderTarget.value = "0"
    this.dialogTarget.close()
  }

  cancel() {
    this.refundedTarget.checked = false
    this.abandonLeaderTarget.value = "0"
    this.dialogTarget.close()
  }

  clickBackdrop(event) {
    if (event.target === this.dialogTarget) this.cancel()
  }
}
